import { render, staticRenderFns } from "./weier_silk_label.vue?vue&type=template&id=20c545c4&scoped=true&"
import script from "./weier_silk_label.vue?vue&type=script&lang=js&"
export * from "./weier_silk_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c545c4",
  null
  
)

export default component.exports